import { ApplicationConfig, Injector } from '@angular/core';
import { provideRouter } from '@angular/router';
import { FirebaseApp, provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { getApp, getApps } from 'firebase/app';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';

function firebaseAppFactory(): ReturnType<typeof initializeApp> {
  const cfg = environment.firebase;
  if (!cfg.apiKey?.trim()) {
    throw new Error(
      'Firebase apiKey is empty. Set src/environments/environment.development.ts (dev) or environment.ts (prod), then restart ng serve.'
    );
  }
  if (getApps().length > 0) {
    return getApp();
  }
  return initializeApp(cfg);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideFirebaseApp(firebaseAppFactory),
    provideAuth((injector: Injector) => getAuth(injector.get(FirebaseApp))),
    provideFirestore((injector: Injector) => getFirestore(injector.get(FirebaseApp)))
  ]
};
